export class RangeItems<T> {
  constructor(public items: { [key: string]: T }) {}
}
